<template>
  <!-- 火箭在 Progress 外：避免 overflow-hidden 裁切 / 指示器 h-full 压扁 -->
  <div class="relative flex h-12 w-full items-center overflow-visible">
    <Progress v-model="progress" class="h-2.5 w-full" />
    <div class="pointer-events-none absolute inset-0 overflow-visible">
      <div
        class="absolute top-1/2 left-0 h-0 w-full transition-all"
        :style="{ transform: `translateX(-${100 - clampedProgress}%)` }"
      >
        <div class="absolute top-0 right-0" style="transform: translate(50%, calc(-50% - 3px))">
          <div class="h-12 w-12 shrink-0">
            <img
              :src="getImageUrl('header/settings/about/rocketIcon.webp')"
              alt="rocket"
              width="48"
              height="48"
              class="block h-12 w-12 rotate-45 object-contain"
              style="max-width: none; max-height: none"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { getImageUrl } from '@/utils/assets'
  import { Progress } from '@rapoo/element'

  const props = defineProps({
    modelValue: {
      type: Number,
      default: 0,
    },
  })
  const emit = defineEmits(['update:modelValue'])

  const progress = computed({
    get() {
      return props.modelValue
    },
    set(val) {
      emit('update:modelValue', val)
    },
  })

  const clampedProgress = computed(() => Math.min(100, Math.max(0, props.modelValue ?? 0)))
</script>
